import Vue from 'vue';
import Vuex from 'vuex';
import fengShang from '@/views/20220325FSDS/store';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pointOut: false,
  },
  mutations: {
    changePointOut(state, data) {
      state.pointOut = data;
    },
  },
  actions: {},
  modules: { fengShang },
});
